var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("div", [
      _c("div", { staticClass: "layer" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("../assets/img/中鑫金.png"), alt: "中鑫金Logo" }
        }),
        _c("img", {
          staticClass: "phone",
          attrs: { src: require("../assets/img/电话@2x.png"), alt: "电话" },
          on: { click: _vm.callPhone }
        }),
        _c("img", {
          staticClass: "address",
          attrs: {
            src: require("../assets/images/aboutUs@2x.png"),
            alt: "关于我们"
          },
          on: { click: _vm.addRouterMap }
        })
      ])
    ]),
    _vm.havedata
      ? _c("div", { staticClass: "totalwidth" }, [
          _c("div", { staticClass: "back" }, [
            _c("div", [
              _c("div", { staticClass: "timeleft" }, [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function($event) {
                        return _vm.quoted()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.timecenter))]
                ),
                _c("div", { staticClass: "open timeright redFont" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.opentrade == true ? "开盘中" : "已停盘") +
                      " "
                  )
                ])
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header" }, [_vm._v("黄金")]),
              _vm._m(0),
              _vm._l(_vm.arrcenter.huangjin, function(items, index) {
                return _c(
                  "div",
                  { key: items.productData["name"], staticClass: "ulcenter" },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "flex ulflex productlist",
                        class:
                          index == _vm.arrcenter.huangjin.length - 1
                            ? "lastul"
                            : index == 0
                            ? "firstul"
                            : ""
                      },
                      [
                        _c("li", { staticClass: "flex_product" }, [
                          _vm._v(_vm._s(items.productData["name"]))
                        ]),
                        _vm.sendmsg
                          ? [
                              _c(
                                "li",
                                {
                                  // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                  class:
                                    //   'huigou'
                                    // ] <= items.productData['huigou']
                                    //   ? 'redfont'
                                    //   : 'greenfont'
                                    items.productData["huigouColor"]
                                },
                                [
                                  items.productData["hgDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["huigou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c(
                                "li",
                                {
                                  // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                  class:
                                    //   'xiaoshou'
                                    // ] <= items.productData['xiaoshou']
                                    //   ? 'redfont'
                                    //   : 'greenfont'
                                    items.productData["huigouColor"]
                                },
                                [
                                  items.productData["xsDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["xiaoshou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c("li", { staticClass: "lastli" }, [
                                _c(
                                  "div",
                                  {
                                    // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                    class:
                                      //   'high'
                                      // ] <= items.productData['high']
                                      //   ? 'redfont'
                                      //   : 'greenfont'
                                      items.productData["huigouColor"]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["high"]
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                    class:
                                      //   'low'
                                      // ] <= items.productData['low']
                                      //   ? 'redfont'
                                      //   : 'greenfont'
                                      items.productData["huigouColor"]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["low"]
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ]
                          : [
                              _c(
                                "li",
                                { staticClass: "redfont" },
                                [
                                  items.productData["hgDisplay"] == "SHOW"
                                    ? [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("changeTwoDecimal_f")(
                                                  items.productData["huigou"]
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c(
                                "li",
                                { staticClass: "redfont" },
                                [
                                  items.productData["xsDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["xiaoshou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c("li", { staticClass: "lastli" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("changeTwoDecimal_f")(
                                        items.productData["high"]
                                      )
                                    )
                                  )
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("changeTwoDecimal_f")(
                                        items.productData["low"]
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                      ],
                      2
                    )
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "hrxian" }),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header fillet" }, [_vm._v("铂金")]),
              _vm._m(1),
              _vm._l(_vm.arrcenter.bojin, function(items, index) {
                return _c(
                  "div",
                  { key: items.productData["name"], staticClass: "ulcenter" },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "flex ulflex productlist",
                        class:
                          index == _vm.arrcenter.bojin.length - 1
                            ? "lastul"
                            : index == 0
                            ? "firstul"
                            : ""
                      },
                      [
                        _c("li", { staticClass: "flex_product" }, [
                          _vm._v(_vm._s(items.productData["name"]))
                        ]),
                        _vm.sendmsg
                          ? [
                              _c(
                                "li",
                                {
                                  // new_tuisong_val_before['bojin'].prices[items['engname']][
                                  class:
                                    //   'huigou'
                                    // ] <= items.productData['huigou']
                                    //   ? 'redfont'
                                    //   : 'greenfont'
                                    items.productData["huigouColor"]
                                },
                                [
                                  items.productData["hgDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["huigou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c(
                                "li",
                                {
                                  // new_tuisong_val_before['bojin'].prices[items['engname']][
                                  class:
                                    //   'xiaoshou'
                                    // ] <= items.productData['xiaoshou']
                                    //   ? 'redfont'
                                    //   : 'greenfont'
                                    items.productData["huigouColor"]
                                },
                                [
                                  items.productData["xsDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["xiaoshou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c("li", { staticClass: "lastli" }, [
                                _c(
                                  "div",
                                  {
                                    // new_tuisong_val_before['bojin'].prices[items['engname']][
                                    class:
                                      //   'high'
                                      // ] <= items.productData['high']
                                      //   ? 'redfont'
                                      //   : 'greenfont'
                                      items.productData["huigouColor"]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["high"]
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    // new_tuisong_val_before['bojin'].prices[items['engname']][
                                    class:
                                      //   'low'
                                      // ] <= items.productData['low']
                                      //   ? 'redfont'
                                      //   : 'greenfont'
                                      items.productData["huigouColor"]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["low"]
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ]
                          : [
                              _c(
                                "li",
                                { staticClass: "redfont" },
                                [
                                  items.productData["hgDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["huigou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c(
                                "li",
                                { staticClass: "redfont" },
                                [
                                  items.productData["xsDisplay"] == "SHOW"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["xiaoshou"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : [_vm._v(" - ")]
                                ],
                                2
                              ),
                              _c("li", { staticClass: "lastli" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("changeTwoDecimal_f")(
                                        items.productData["high"]
                                      )
                                    )
                                  )
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("changeTwoDecimal_f")(
                                        items.productData["low"]
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                      ],
                      2
                    )
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "hrxian" }),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header fillet" }, [_vm._v("钯金")]),
              _vm._m(2),
              _vm._l(_vm.arrcenter.bajin, function(items, index) {
                return _c(
                  "div",
                  { key: items.productData["name"], staticClass: "ulcenter" },
                  [
                    items.productData["display"] == "SHOW"
                      ? _c(
                          "ul",
                          {
                            staticClass: "flex ulflex productlist",
                            class:
                              index == _vm.arrcenter.bajin.length - 1
                                ? "lastul"
                                : index == 0
                                ? "firstul"
                                : ""
                          },
                          [
                            _c("li", { staticClass: "flex_product" }, [
                              _vm._v(_vm._s(items.productData["name"]))
                            ]),
                            _vm.sendmsg
                              ? [
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['bajin'].prices[items['engname']][
                                      class:
                                        //   'huigou'
                                        // ] <= items.productData['huigou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData["huigou"]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['bajin'].prices[items['engname']][
                                      class:
                                        //   'xiaoshou'
                                        // ] <= items.productData['xiaoshou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c(
                                      "div",
                                      {
                                        // new_tuisong_val_before['bajin'].prices[items['engname']][
                                        class:
                                          //   'high'
                                          // ] <= items.productData['high']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["high"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        // new_tuisong_val_before['bajin'].prices[items['engname']][
                                        class:
                                          //   'low'
                                          // ] <= items.productData['low']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_f")(
                                                items.productData["low"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              : [
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData["huigou"]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["high"]
                                          )
                                        )
                                      )
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("changeTwoDecimal_f")(
                                            items.productData["low"]
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "hrxian" }),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header fillet" }, [_vm._v("白银")]),
              _vm._m(3),
              _vm._l(_vm.arrcenter.baiyin, function(items, index) {
                return _c(
                  "div",
                  { key: items["engname"], staticClass: "ulcenter" },
                  [
                    items.productData["display"] == "SHOW"
                      ? _c(
                          "ul",
                          {
                            staticClass: "flex ulflex productlist",
                            class:
                              index == _vm.arrcenter.baiyin.length - 1
                                ? "lastul"
                                : index == 0
                                ? "firstul"
                                : ""
                          },
                          [
                            _c("li", { staticClass: "flex_product" }, [
                              _vm._v(_vm._s(items.productData["name"]))
                            ]),
                            _vm.sendmsg
                              ? [
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['baiyin'].prices[items['engname']][
                                      class:
                                        //   'huigou'
                                        // ] <= items.productData['huigou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(items.productData["huigou"])
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['baiyin'].prices[items['engname']][
                                      class:
                                        //   'xiaoshou'
                                        // ] <= items.productData['xiaoshou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c(
                                      "div",
                                      {
                                        // new_tuisong_val_before['baiyin'].prices[items['engname']][
                                        class:
                                          //   'high'
                                          // ] <= items.productData['high']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_fthree")(
                                                items.productData["high"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.new_tuisong_val_before["baiyin"]
                                            .prices[items["engname"]]["low"] <=
                                          items.productData["low"]
                                            ? "redfont"
                                            : "greenfont"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("changeTwoDecimal_fthree")(
                                                items.productData["low"]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              : [
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(items.productData["huigou"])
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("changeTwoDecimal_fthree")(
                                              items.productData["high"]
                                            )
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("changeTwoDecimal_fthree")(
                                              items.productData["low"]
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ])
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "hrxian" }),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header fillet" }, [_vm._v("上交所")]),
              _vm._m(4),
              _vm._l(_vm.arrcenter.shangjinsuo, function(items, index) {
                return _c(
                  "div",
                  { key: items.productData["name"], staticClass: "ulcenter" },
                  [
                    items.productData["display"] == "SHOW"
                      ? _c(
                          "ul",
                          {
                            staticClass: "flex ulflex productlist",
                            class:
                              index == _vm.arrcenter.shangjinsuo.length - 1
                                ? "lastul"
                                : index == 0
                                ? "firstul"
                                : ""
                          },
                          [
                            _c("li", { staticClass: "flex_product" }, [
                              _vm._v(_vm._s(items.productData["name"]))
                            ]),
                            _vm.sendmsg
                              ? [
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['sge'].prices[items['engname']][
                                      class:
                                        //   'huigou'
                                        // ] <= items.productData['huigou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            items.productData["name"] ==
                                            "白银(T+D)"
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        items.productData[
                                                          "huigou"
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "changeTwoDecimal_f"
                                                        )(
                                                          items.productData[
                                                            "huigou"
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['sge'].prices[items['engname']][
                                      class:
                                        //   'xiaoshou'
                                        // ] <= items.productData['xiaoshou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            items.productData["name"] ==
                                            "白银(T+D)"
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        items.productData[
                                                          "xiaoshou"
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "changeTwoDecimal_f"
                                                        )(
                                                          items.productData[
                                                            "xiaoshou"
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    { staticClass: "lastli" },
                                    [
                                      items.productData["name"] == "白银(T+D)"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                // new_tuisong_val_before['sge'].prices[items['engname']][
                                                class:
                                                  //   'high'
                                                  // ] <= items.productData['high']
                                                  //   ? 'redfont'
                                                  //   : 'greenfont'
                                                  items.productData[
                                                    "huigouColor"
                                                  ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      items.productData["high"]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                // new_tuisong_val_before['sge'].prices[items['engname']][
                                                class:
                                                  //   'low'
                                                  // ] <= items.productData['low']
                                                  //   ? 'redfont'
                                                  //   : 'greenfont'
                                                  items.productData[
                                                    "huigouColor"
                                                  ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      items.productData["low"]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                // new_tuisong_val_before['sge'].prices[items['engname']][
                                                class:
                                                  //   'high'
                                                  // ] <= items.productData['high']
                                                  //   ? 'redfont'
                                                  //   : 'greenfont'
                                                  items.productData[
                                                    "huigouColor"
                                                  ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "changeTwoDecimal_f"
                                                      )(
                                                        items.productData[
                                                          "high"
                                                        ]
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                // new_tuisong_val_before['sge'].prices[items['engname']][
                                                class:
                                                  //   'low'
                                                  // ] <= items.productData['low']
                                                  //   ? 'redfont'
                                                  //   : 'greenfont'
                                                  items.productData[
                                                    "huigouColor"
                                                  ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "changeTwoDecimal_f"
                                                      )(
                                                        items.productData["low"]
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              : [
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["hgDisplay"] == "SHOW"
                                        ? [
                                            items.productData["name"] ==
                                            "白银(T+D)"
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        items.productData[
                                                          "huigou"
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "changeTwoDecimal_f"
                                                        )(
                                                          items.productData[
                                                            "huigou"
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["xsDisplay"] == "SHOW"
                                        ? [
                                            items.productData["name"] ==
                                            "白银(T+D)"
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        items.productData[
                                                          "xiaoshou"
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "changeTwoDecimal_f"
                                                        )(
                                                          items.productData[
                                                            "xiaoshou"
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                          ]
                                        : [_vm._v(" - ")]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    { staticClass: "lastli" },
                                    [
                                      items.productData["name"] == "白银(T+D)"
                                        ? [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  items.productData["high"]
                                                )
                                              )
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(items.productData["low"])
                                              )
                                            ])
                                          ]
                                        : [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_f"
                                                    )(items.productData["high"])
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData["low"]
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                    ],
                                    2
                                  )
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "hrxian" }),
          _c(
            "div",
            { staticClass: "productitems" },
            [
              _c("div", { staticClass: "header fillet" }, [_vm._v("国际现货")]),
              _vm._m(5),
              _vm._l(_vm.arrcenter.guojixianhuo, function(items, index) {
                return _c(
                  "div",
                  { key: items.productData["name"], staticClass: "ulcenter" },
                  [
                    items.productData["display"] == "SHOW"
                      ? _c(
                          "ul",
                          {
                            staticClass: "flex ulflex productlist",
                            class:
                              index == _vm.arrcenter.guojixianhuo.length - 1
                                ? "lastul"
                                : index == 0
                                ? "firstul"
                                : ""
                          },
                          [
                            _c("li", { staticClass: "flex_product" }, [
                              _vm._v(_vm._s(items.productData["name"]))
                            ]),
                            _vm.sendmsg
                              ? [
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['international'].prices[
                                      class:
                                        //   items['engname']
                                        // ]['huigou'] <= items.productData['huigou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["name"] == "伦敦金" ||
                                      items.productData["name"] == "伦敦钯" ||
                                      items.productData["name"] == "伦敦铂"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData["huigou"]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : items.productData["name"] ==
                                            "伦敦银" ||
                                          items.productData["name"] ==
                                            "美元指数"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(items.productData["huigou"])
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  items.productData["huigou"]
                                                ) +
                                                " "
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "li",
                                    {
                                      // new_tuisong_val_before['international'].prices[
                                      class:
                                        //   items['engname']
                                        // ]['xiaoshou'] <= items.productData['xiaoshou']
                                        //   ? 'redfont'
                                        //   : 'greenfont'
                                        items.productData["huigouColor"]
                                    },
                                    [
                                      items.productData["name"] == "伦敦金" ||
                                      items.productData["name"] == "伦敦钯" ||
                                      items.productData["name"] == "伦敦铂"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : items.productData["name"] ==
                                            "伦敦银" ||
                                          items.productData["name"] ==
                                            "美元指数"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(
                                                    items.productData[
                                                      "xiaoshou"
                                                    ]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  items.productData["xiaoshou"]
                                                ) +
                                                " "
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c(
                                      "div",
                                      {
                                        // new_tuisong_val_before['international'].prices[
                                        class:
                                          //   items['engname']
                                          // ]['high'] <= items.productData['high']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        items.productData["name"] == "伦敦金" ||
                                        items.productData["name"] == "伦敦钯" ||
                                        items.productData["name"] == "伦敦铂"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_f"
                                                    )(items.productData["high"])
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : items.productData["name"] ==
                                              "伦敦银" ||
                                            items.productData["name"] ==
                                              "美元指数"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_fthree"
                                                    )(items.productData["high"])
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    items.productData["high"]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        // new_tuisong_val_before['international'].prices[
                                        class:
                                          //   items['engname']
                                          // ]['low'] <= items.productData['low']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        items.productData["name"] == "伦敦金" ||
                                        items.productData["name"] == "伦敦钯" ||
                                        items.productData["name"] == "伦敦铂"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_f"
                                                    )(items.productData["low"])
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : items.productData["name"] ==
                                              "伦敦银" ||
                                            items.productData["name"] ==
                                              "美元指数"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_fthree"
                                                    )(items.productData["low"])
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    items.productData["low"]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              : [
                                  _c(
                                    "li",
                                    { staticClass: "redfont" },
                                    [
                                      items.productData["name"] == "伦敦金" ||
                                      items.productData["name"] == "伦敦钯" ||
                                      items.productData["name"] == "伦敦铂"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("changeTwoDecimal_f")(
                                                    items.productData["huigou"]
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        : items.productData["name"] ==
                                            "伦敦银" ||
                                          items.productData["name"] ==
                                            "美元指数"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "changeTwoDecimal_fthree"
                                                  )(items.productData["huigou"])
                                                ) +
                                                " "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  items.productData["huigou"]
                                                ) +
                                                " "
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _c("li", { staticClass: "redfont" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(items.productData["xiaoshou"]) +
                                        " "
                                    )
                                  ]),
                                  _c("li", { staticClass: "lastli" }, [
                                    _c("div", [
                                      _vm._v(_vm._s(items.productData["high"]))
                                    ]),
                                    _c("div", [
                                      _vm._v(_vm._s(items.productData["low"]))
                                    ])
                                  ])
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          ),
          _c("div", { staticClass: "spacing" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "flex ulflex topul" }, [
      _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
      _c("li", [_vm._v("高/低")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }